import React from 'react';
import Header from './components/Header';
import Home from './components/Home';
import SocialProof from './components/SocialProof';
import Services from './components/Services';
import About from './components/About';
import StaffHighlights from './components/StaffHighlights';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App app-shell">
      <Header />
      <main>
        <Home />
        <SocialProof />
        <Services />
        <About />
        <StaffHighlights />
        <Pricing />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
